import { render } from "./BoardNoticeEditForm.vue?vue&type=template&id=790aa84f&lang=true"
import script from "./BoardNoticeEditForm.vue?vue&type=script&lang=js"
export * from "./BoardNoticeEditForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__